import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useHistoryContext } from "../../../hooks/useHistoryContext"

const RouteListener = () => {
  const { pathname } = useLocation();
  const { updateHistory } = useHistoryContext();

  useEffect(() => {
    // Actualiza solo si el pathname cambia
    updateHistory(pathname);
  }, [pathname, updateHistory]);

  return null;
};

export default RouteListener;
